import axios from 'axios';
import { setAlert } from "./alert";

import { url } from '../utils/api';
import { ADD_BAR, BAR_BOOKINGS, BAR_ERROR, BOOK_BAR, CANCEL_BAR_BOOKING, DELETE_BAR_BOOKING, LOAD_BAR, MY_BAR_BOOKINGS } from './types';

// Get bars
export const getBars = () => async dispatch => {
      const config = {
          headers: {
              'Content-Type': 'application/json',
          }
      }
      try {
          const res = await axios.get(`${url}/api/bar`, config);
  
          dispatch({
              type: LOAD_BAR,
              payload: res.data
          });
      } catch (err) {
          dispatch({
              type: BAR_ERROR,
              payload: { msg: err.response.statusText, status: err.response.status}
          });
      }
  }
  
// Add bar
export const addBar = (formData, navigate) => async dispatch => {
      const config = {
          headers: {
              'Content-Type': 'application/json',
          }
      }
      try {
          const res = await axios.post(`${url}/api/bar/add`, formData, config);
  
          dispatch({
              type: ADD_BAR,
              payload: res.data
          });
  
          dispatch(setAlert('Added a new bar', 'success'));
          navigate('/adminDashboard/bar');
      } catch (err) {
          dispatch(setAlert('Error in adding bar', 'danger'));
          dispatch({
              type: BAR_ERROR,
              payload: { msg: err.response.statusText, status: err.response.status}
          });
          
      }
}


// Get Bar Booking
export const getBarBookings = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    try {
        const res = await axios.get(`${url}/api/bar/bookings`, config);

        dispatch({
            type: BAR_BOOKINGS,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: BAR_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status}
        });
    }
}

// Get my bookings
export const getMyBarBooking = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    try {
        const res = await axios.get(`${url}/api/bar/bookings/me`, config);
        dispatch({
            type: MY_BAR_BOOKINGS,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: BAR_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status}
        });
    }
}

// Add bar booking
export const addBarBooking = (formData, navigate) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    try {
        const res = await axios.post(`${url}/api/bar/book`, formData, config);

        dispatch({
            type: BOOK_BAR,
            payload: res.data
        });

        dispatch(setAlert('Added a new booking. Go to Bar Bookings.', 'success'));
        navigate('/barbookings');
    } catch (err) {
        dispatch(setAlert('Error in booking bar', 'danger'));
        dispatch({
            type: BAR_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status}
        });
    }
}

// Cancel booking
export const cancelBarBooking = (_id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    if(window.confirm('Are you sure about cancelling this booking? This can NOT be undone!')) {
        try {
            const res = await axios.put(`${url}/api/bar/bookings/cancel/${_id}`, config);

            dispatch({
                type: CANCEL_BAR_BOOKING,
                payload: {_id, status: res.data.status}
            });
            dispatch(setAlert('Cancelled a bar booking.', 'success'));
            //navigate('/bookings');
        } catch (err) {
            dispatch(setAlert('Cancelling Error. Try again.', 'danger'));
            dispatch({
                type: BAR_ERROR,
                payload: { msg: err.response.statusText, status: err.response.status}
            });
        }
    }
}

// Delete Booking
export const deleteBarBooking = (_id, navigate) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    if(window.confirm('Are you sure about deleting this booking? This can NOT be undone!')) {
        try {
            await axios.delete(`${url}/api/bar/bookings/${_id}`, config);

            dispatch({
                type: DELETE_BAR_BOOKING,
                payload: _id
            });
            navigate('/barbookings');
            dispatch(setAlert('Bar Booking Deleted', 'success'));
        } catch (err) {
            dispatch({
                type: BAR_ERROR,
                payload: { msg: err.response.statusText, status: err.response.status}
            });
        }
    }
};
